import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

export function useUsers(token, page, size, search) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    setError(null);
    const fetchUsers = async () => {
      try {
        let url;
        if (search && search.length > 0) {
          url = `${BASE_URL}user-collection/search?q=${encodeURIComponent(search)}`;
        } else {
          url = `${BASE_URL}user-collection?page=${page}&size=${size}`;
        }
        const res = await fetch(url, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        });
        if (!res.ok) throw new Error("Erro ao buscar usuários");
        const data = await res.json();
        if (search && search.length > 0) {
          setUsers(data || []);
          setTotalPages(1);
        } else {
          setUsers(data.content || []);
          setTotalPages(data.totalPages || 1);
        }
      } catch (err) {
        setError(err.message);
        setUsers([]);
        setTotalPages(1);
      }
      setLoading(false);
    };
    fetchUsers();
  }, [token, page, size, search]);

  return { users, loading, totalPages, error };
}
